module.exports = __webpack_public_path__ + "static/media/logo-capifrance-blanc.96812a30.png";